// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem 1rem;
}

.dashboard-header {
  text-align: center;
  margin-bottom: 2rem;
}

.dashboard-header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 0.5rem;
}

.dashboard-header p {
  font-size: 1.125rem;
  color: #4a5568;
  margin: 0;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard-grid-3-col {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-lg);
  grid-template-rows: auto auto;
}

.dashboard-grid-4-col {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-lg);
  grid-template-rows: auto auto;
}

/* Wallet Card */
.wallet-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
}

.wallet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.wallet-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.wallet-actions {
  display: flex;
  gap: 0.5rem;
}

.wallet-balance {
  text-align: center;
  margin-bottom: 2rem;
}

.balance-amount {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.balance-label {
  font-size: 1rem;
  opacity: 0.9;
}

.wallet-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.stat-item {
  text-align: center;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
}

.stat-label {
  display: block;
  font-size: 0.875rem;
  opacity: 0.8;
  margin-bottom: 0.25rem;
}

.stat-value {
  display: block;
  font-size: 1.125rem;
  font-weight: 600;
}

/* Quick Actions Card */
.quick-actions-card h3 {
  margin-bottom: 1.5rem;
  color: #1a202c;
}

.quick-actions-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

/* Transactions Card */
.transactions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.transactions-header h3 {
  margin: 0;
  color: #1a202c;
}

.transactions-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.transaction-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease-in-out;
}

.transaction-item:hover {
  background: #f1f5f9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.transaction-info {
  flex: 1 1;
}

.transaction-type {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
}

.type-icon {
  font-size: 1.25rem;
}

.type-label {
  font-weight: 600;
  color: #1a202c;
}

.transaction-description {
  font-size: 0.875rem;
  color: #4a5568;
}

.transaction-amount {
  text-align: right;
  margin-right: 1rem;
}

.amount {
  display: block;
  font-weight: 600;
  font-size: 1.125rem;
}

.amount.positive {
  color: #10b981;
}

.amount.negative {
  color: #ef4444;
}

.transaction-date {
  display: block;
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 0.25rem;
}

.transaction-status {
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
}

.status-pending {
  background: #fef3c7;
  color: #92400e;
}

.status-completed {
  background: #d1fae5;
  color: #065f46;
}

.status-failed {
  background: #fee2e2;
  color: #991b1b;
}

.status-cancelled {
  background: #f3f4f6;
  color: #374151;
}

/* Account Status Card */
.account-status-card h3 {
  margin-bottom: 1.5rem;
  color: #1a202c;
}

.status-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
}

.status-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.status-info {
  flex: 1 1;
}

.status-label {
  display: block;
  font-weight: 500;
  color: #1a202c;
  margin-bottom: 0.25rem;
}

.status-value {
  display: block;
  font-size: 0.875rem;
  color: #4a5568;
}

/* Loading States */
/* Dashboard-specific loading spinner */
.dashboard-loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
}

.dashboard-spinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

.loading-transactions {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
}

.loading-transactions .dashboard-spinner {
  width: 1.5rem;
  height: 1.5rem;
  border-width: 2px;
}

/* Error States */
.auth-required,
.error-message {
  text-align: center;
  padding: 3rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: 0 auto;
}

.auth-required h2,
.error-message h2 {
  color: #1a202c;
  margin-bottom: 1rem;
}

.auth-required p,
.error-message p {
  color: #4a5568;
  margin-bottom: 1.5rem;
}

/* No Transactions */
.no-transactions {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
}

.no-transactions p {
  margin-bottom: 1rem;
}

/* Dashboard Modal Styles - Scoped to dashboard-container */
.dashboard-container .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.dashboard-container .modal-content {
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.dashboard-container .modal-card {
  margin: 0;
}

.dashboard-container .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.dashboard-container .modal-header h2 {
  margin: 0;
  color: #1a202c;
}

.dashboard-container .modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6b7280;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: all 0.2s ease-in-out;
}

.dashboard-container .modal-close:hover {
  background: #f3f4f6;
  color: #1a202c;
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Dashboard form-group - scoped */
.dashboard-container .form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.dashboard-container .form-group label {
  font-weight: 500;
  color: #374151;
}

.dashboard-container .form-group input,
.dashboard-container .form-group select {
  padding: 0.75rem;
  border: 2px solid #e5e7eb;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.2s ease-in-out;
  background: white;
  color: #1f2937;
}

.dashboard-container .form-group input:focus,
.dashboard-container .form-group select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.dashboard-container .form-group small {
  font-size: 0.875rem;
  color: #6b7280;
}

.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .dashboard-grid-3-col {
    grid-template-columns: repeat(2, 1fr);
  }
  .dashboard-grid-4-col {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .dashboard-container {
    padding: 1rem;
  }
  
  .dashboard-header h1 {
    font-size: 2rem;
  }
  
  .dashboard-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .dashboard-grid-3-col {
    grid-template-columns: 1fr;
  }
  
  .dashboard-grid-4-col {
    grid-template-columns: 1fr;
  }
  
  .wallet-stats {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  .quick-actions-grid {
    grid-template-columns: 1fr;
  }
  
  .transaction-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .transaction-amount {
    text-align: left;
    margin-right: 0;
  }
  
  .modal-content {
    max-width: none;
    margin: 0 1rem;
  }
  
  .form-actions {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .dashboard-header h1 {
    font-size: 1.75rem;
  }
  
  .balance-amount {
    font-size: 2.5rem;
  }
  
  .wallet-actions {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .transactions-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;;EAEE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF","sourcesContent":[".dashboard-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  padding: 2rem 1rem;\n}\n\n.dashboard-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.dashboard-header h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin-bottom: 0.5rem;\n}\n\n.dashboard-header p {\n  font-size: 1.125rem;\n  color: #4a5568;\n  margin: 0;\n}\n\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.dashboard-grid-3-col {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--spacing-lg);\n  grid-template-rows: auto auto;\n}\n\n.dashboard-grid-4-col {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--spacing-lg);\n  grid-template-rows: auto auto;\n}\n\n/* Wallet Card */\n.wallet-card {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n}\n\n.wallet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.wallet-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.wallet-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.wallet-balance {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.balance-amount {\n  font-size: 3rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.balance-label {\n  font-size: 1rem;\n  opacity: 0.9;\n}\n\n.wallet-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n}\n\n.stat-item {\n  text-align: center;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 0.5rem;\n}\n\n.stat-label {\n  display: block;\n  font-size: 0.875rem;\n  opacity: 0.8;\n  margin-bottom: 0.25rem;\n}\n\n.stat-value {\n  display: block;\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n\n/* Quick Actions Card */\n.quick-actions-card h3 {\n  margin-bottom: 1.5rem;\n  color: #1a202c;\n}\n\n.quick-actions-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n}\n\n/* Transactions Card */\n.transactions-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.transactions-header h3 {\n  margin: 0;\n  color: #1a202c;\n}\n\n.transactions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.transaction-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: #f8fafc;\n  border-radius: 0.5rem;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease-in-out;\n}\n\n.transaction-item:hover {\n  background: #f1f5f9;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.transaction-info {\n  flex: 1;\n}\n\n.transaction-type {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.25rem;\n}\n\n.type-icon {\n  font-size: 1.25rem;\n}\n\n.type-label {\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.transaction-description {\n  font-size: 0.875rem;\n  color: #4a5568;\n}\n\n.transaction-amount {\n  text-align: right;\n  margin-right: 1rem;\n}\n\n.amount {\n  display: block;\n  font-weight: 600;\n  font-size: 1.125rem;\n}\n\n.amount.positive {\n  color: #10b981;\n}\n\n.amount.negative {\n  color: #ef4444;\n}\n\n.transaction-date {\n  display: block;\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin-top: 0.25rem;\n}\n\n.transaction-status {\n  padding: 0.25rem 0.75rem;\n  border-radius: 1rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.status-pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-completed {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status-cancelled {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n/* Account Status Card */\n.account-status-card h3 {\n  margin-bottom: 1.5rem;\n  color: #1a202c;\n}\n\n.status-items {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.status-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f8fafc;\n  border-radius: 0.5rem;\n  border: 1px solid #e2e8f0;\n}\n\n.status-icon {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n}\n\n.status-info {\n  flex: 1;\n}\n\n.status-label {\n  display: block;\n  font-weight: 500;\n  color: #1a202c;\n  margin-bottom: 0.25rem;\n}\n\n.status-value {\n  display: block;\n  font-size: 0.875rem;\n  color: #4a5568;\n}\n\n/* Loading States */\n/* Dashboard-specific loading spinner */\n.dashboard-loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n}\n\n.dashboard-spinner {\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n.loading-transactions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2rem;\n}\n\n.loading-transactions .dashboard-spinner {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-width: 2px;\n}\n\n/* Error States */\n.auth-required,\n.error-message {\n  text-align: center;\n  padding: 3rem;\n  background: white;\n  border-radius: 1rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.auth-required h2,\n.error-message h2 {\n  color: #1a202c;\n  margin-bottom: 1rem;\n}\n\n.auth-required p,\n.error-message p {\n  color: #4a5568;\n  margin-bottom: 1.5rem;\n}\n\n/* No Transactions */\n.no-transactions {\n  text-align: center;\n  padding: 2rem;\n  color: #6b7280;\n}\n\n.no-transactions p {\n  margin-bottom: 1rem;\n}\n\n/* Dashboard Modal Styles - Scoped to dashboard-container */\n.dashboard-container .modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.dashboard-container .modal-content {\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.dashboard-container .modal-card {\n  margin: 0;\n}\n\n.dashboard-container .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.dashboard-container .modal-header h2 {\n  margin: 0;\n  color: #1a202c;\n}\n\n.dashboard-container .modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.dashboard-container .modal-close:hover {\n  background: #f3f4f6;\n  color: #1a202c;\n}\n\n.modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n/* Dashboard form-group - scoped */\n.dashboard-container .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.dashboard-container .form-group label {\n  font-weight: 500;\n  color: #374151;\n}\n\n.dashboard-container .form-group input,\n.dashboard-container .form-group select {\n  padding: 0.75rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  transition: all 0.2s ease-in-out;\n  background: white;\n  color: #1f2937;\n}\n\n.dashboard-container .form-group input:focus,\n.dashboard-container .form-group select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.dashboard-container .form-group small {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .dashboard-grid-3-col {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .dashboard-grid-4-col {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-container {\n    padding: 1rem;\n  }\n  \n  .dashboard-header h1 {\n    font-size: 2rem;\n  }\n  \n  .dashboard-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .dashboard-grid-3-col {\n    grid-template-columns: 1fr;\n  }\n  \n  .dashboard-grid-4-col {\n    grid-template-columns: 1fr;\n  }\n  \n  .wallet-stats {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n  \n  .quick-actions-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .transaction-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n  \n  .transaction-amount {\n    text-align: left;\n    margin-right: 0;\n  }\n  \n  .modal-content {\n    max-width: none;\n    margin: 0 1rem;\n  }\n  \n  .form-actions {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard-header h1 {\n    font-size: 1.75rem;\n  }\n  \n  .balance-amount {\n    font-size: 2.5rem;\n  }\n  \n  .wallet-actions {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .transactions-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
